import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import {
  createSportsbookState,
  SiteConfigManager,
  SportsbookProvider,
  useSettings,
} from '@atlas/core';
import { SportsbookRouter } from '@atlas/routing';

import { SIMPLIFIED_SPORTSBOOK_PATH_PATTERN } from 'common/constants';
import SportsbookMaintenanceContainer from 'components/MaintenanceContainer/SportsbookMaintenanceContainer';
import SimplifiedSportsbookView from 'components/Pages/Prematch/SimplifiedSportsbookView';

import LiveSportsbookView from './LiveSportsbookView';

const LiveSportsbookProvider = props => {
  const { children, sportsbookProps } = props;

  const { categoryName, sportName, tournamentName } = useParams();

  const sportsbookState = createSportsbookState({
    id: 'live',
    selectedCategoryUrlName: categoryName,
    selectedSportUrlName: sportName,
    selectedTournamentUrlName: tournamentName,
    sportService: 'LIVE',
    ...sportsbookProps,
  });

  return <SportsbookProvider value={sportsbookState}>{children}</SportsbookProvider>;
};

const LiveSportsbook = () => {
  const { lang } = useSettings();
  const {
    location: { state = {} },
    push: historyPush,
  } = useHistory();

  React.useEffect(() => {
    if (state?.redirectPath) historyPush(state.redirectPath);
  }, [state?.redirectPath, historyPush]);

  const isSimplifiedView = React.useMemo(
    () => SiteConfigManager.getConfig('config.config.sportsbook.mobileGridViewType'),
    [],
  );

  const props = {};
  const sportsbookProps = {};

  if (isSimplifiedView === 'simplified') {
    props.path = SIMPLIFIED_SPORTSBOOK_PATH_PATTERN;
    sportsbookProps.showAllSports = true;
  }

  return (
    <SportsbookMaintenanceContainer>
      <SportsbookRouter {...props}>
        <LiveSportsbookProvider key={lang} sportsbookProps={sportsbookProps}>
          {isSimplifiedView === 'simplified' ? (
            <SimplifiedSportsbookView path="/live" />
          ) : (
            <LiveSportsbookView />
          )}
        </LiveSportsbookProvider>
      </SportsbookRouter>
    </SportsbookMaintenanceContainer>
  );
};

export default LiveSportsbook;
